import 'twin.macro';
import React, { useState } from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { Tag } from '@teetsh/app/src/components/Tag';
import Dialog from '@teetsh/app/src/components/Dialog';
import { useTranslation } from 'react-i18next';
import { ExtensionTeetshTuto } from 'components/ExtensionTeetshTuto';
import { OndeFileTuto } from 'components/OndeFileTuto';

interface Props {
  onNext: () => void;
}

export function DownloadCsv(props: Props) {
  const { onNext } = props;
  const { t } = useTranslation(['eleve', 'common']);
  const [showExtensionTutoModal, setShowExtensionTutoModal] = useState(false);
  const [showOndeTutoModal, setShowOndeTutoModal] = useState(false);

  return (
    <div tw="flex flex-col gap-4">
      <div tw="bg-neutral-supershy rounded-lg p-6 flex flex-col gap-2 md:flex-row md:items-start md:gap-4">
        <div tw="flex-1">
          <div tw="flex flex-wrap items-center gap-1 mb-1 md:gap-2">
            <h3 tw="text-neutral-intense text-base font-bold">
              {t('eleve:import.extensionOption')}
            </h3>
            <Tag size="sm" color="green">
              {t('eleve:import.recommended')}
            </Tag>
          </div>
          <p tw="text-neutral-moderate text-sm">
            {t('eleve:import.extensionDescription')}
          </p>
        </div>
        <div tw="flex justify-center md:justify-start md:shrink-0">
          <Button
            onClick={e => {
              e.stopPropagation();
              setShowExtensionTutoModal(true);
            }}
            outlined
            small
            intent="none"
          >
            {t('eleve:import.installExtension')}
          </Button>
          <Dialog
            size="xl"
            disabledClickOutside={false}
            closeButton
            isOpen={showExtensionTutoModal}
            onClose={() => setShowExtensionTutoModal(false)}
            position="top"
          >
            <Dialog.Body tw="bg-white">
              <ExtensionTeetshTuto />
            </Dialog.Body>
          </Dialog>
        </div>
      </div>

      <div tw="text-center text-neutral-supershy font-medium text-sm uppercase">
        {t('common:or')}
      </div>

      {/* ONDE Option */}
      <div tw="bg-neutral-supershy rounded-lg p-6 flex flex-col gap-2 md:flex-row md:items-start md:gap-4">
        <div tw="flex-1">
          <h3 tw="text-neutral-intense text-base font-bold mb-1">
            {t('eleve:import.ondeOption')}
          </h3>
          <p tw="text-neutral-moderate text-sm">
            {t('eleve:import.ondeDescription')}
          </p>
        </div>
        <div tw="flex justify-center md:justify-start md:shrink-0">
          <Button
            onClick={e => {
              e.stopPropagation();
              setShowOndeTutoModal(true);
            }}
            outlined
            small
            intent="none"
          >
            {t('eleve:import.viewTutorial')}
          </Button>
          <Dialog
            size="xl"
            disabledClickOutside={false}
            closeButton
            isOpen={showOndeTutoModal}
            onClose={() => setShowOndeTutoModal(false)}
            position="top"
          >
            <Dialog.Body tw="bg-white">
              <OndeFileTuto />
            </Dialog.Body>
          </Dialog>
        </div>
      </div>
      <div tw="flex justify-end">
        <Button intent="primary" onClick={onNext}>
          {t('common:buttons.next')}
        </Button>
      </div>
    </div>
  );
}
